import { render } from "./VegetarianSummary.vue?vue&type=template&id=2e5814a2"
import script from "./VegetarianSummary.vue?vue&type=script&lang=js"
export * from "./VegetarianSummary.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__